import { AddressErrorsList, AddressErrorsType } from '../types'

import { useSetErrorAddress } from './useSetErrorAddress'
import { AddressSliceKey } from './useAddressState'

// устанавливает ошибку для текущего адреса
export const useSetAddressError = (addressKey: AddressSliceKey = 'default') => {
  const setErrorAddress = useSetErrorAddress(addressKey)
  return (error: AddressErrorsList) => {
    setErrorAddress(error, AddressErrorsType[error])
  }
}
